<div class="server-settings-root">
	<h1 style="margin-bottom: 20px;">Lucidchart&reg; Settings</h1>
	<form [formGroup]="form">
		<div class="form-group row mb-3">
			<div>
				<input type="checkbox" [formControl]="enabled" />
				<span class="uv-checkbox-label">Enable Lucidchart&reg;</span>
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !serverURL.value}">
			<span class="col-lg-2">Server URL:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="serverURL" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiServerURL.value}">
			<span class="col-lg-2">API Server URL:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="apiServerURL" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiKey.value}">
			<span class="col-lg-2">API Key:</span>
			<div class="col-lg-5">
				<input class="form-control" type="password" [formControl]="apiKey" (keydown)="onApiKeyKeyDownHandler($event)" />
			</div>
		</div>
		<div class="lucidchart-default-settings-divider"></div>
		<button pButton (click)="onSave()" [disabled]="!form.dirty" label="Save Lucidchart Default Settings"></button>
		<div class="lucidchart-default-settings-divider"></div>
	</form>
</div>